export const ISO2_LANGUAGE_CODE_REGEX = /^[a-z]{2}$/;
const LEGACY_ISO3_TO_ISO2 = {
    en: 'en',
    eng: 'en',
    it: 'it',
    ita: 'it',
    de: 'de',
    ger: 'de',
    deu: 'de',
    fra: 'fr',
    fre: 'fr',
    spa: 'es',
};
export function normalizeLanguageCode(input) {
    if (typeof input !== 'string') {
        return null;
    }
    const candidate = input
        .trim()
        .toLowerCase()
        .replace(/_/g, '-')
        .split('-')[0] ?? '';
    if (ISO2_LANGUAGE_CODE_REGEX.test(candidate)) {
        return candidate;
    }
    return null;
}
export function toLanguageAliasKey(input) {
    if (typeof input !== 'string') {
        return '';
    }
    return input.trim().toLowerCase().replace(/_/g, '-');
}
export function normalizeLanguageAliasCode(input) {
    const iso2 = normalizeLanguageCode(input);
    if (iso2) {
        return iso2;
    }
    const alias = toLanguageAliasKey(input);
    if (!alias) {
        return null;
    }
    return LEGACY_ISO3_TO_ISO2[alias] ?? null;
}
export function normalizeBooleanQueryParam(input) {
    if (typeof input !== 'string') {
        return false;
    }
    return input.trim().toLowerCase() === 'true';
}
export function normalizeLanguageMap(value, aliases = {}) {
    const normalized = {};
    Object.entries(value).forEach(([rawCode, rawValue]) => {
        const key = toLanguageAliasKey(rawCode);
        const normalizedCode = normalizeLanguageCode(key) ?? aliases[key] ?? normalizeLanguageAliasCode(key);
        if (!normalizedCode || normalized[normalizedCode] !== undefined) {
            return;
        }
        normalized[normalizedCode] = rawValue;
    });
    return normalized;
}
export function resolveLocalizedValue(source, options = {}) {
    const preferredLanguage = normalizeLanguageCode(options.preferredLanguage) ?? null;
    const resolvedLanguage = normalizeLanguageCode(options.resolvedLanguage) ?? null;
    const fallbackLanguage = normalizeLanguageCode(options.fallbackLanguage) ?? null;
    if (source == null) {
        return {
            value: null,
            language: preferredLanguage ?? resolvedLanguage ?? fallbackLanguage,
            usedFallback: false,
        };
    }
    if (typeof source !== 'object' || Array.isArray(source)) {
        return {
            value: source,
            language: preferredLanguage ?? resolvedLanguage ?? fallbackLanguage,
            usedFallback: false,
        };
    }
    const normalizedMap = normalizeLanguageMap(source, options.aliases);
    const entries = Object.entries(normalizedMap);
    if (entries.length === 0) {
        return {
            value: null,
            language: preferredLanguage ?? resolvedLanguage ?? fallbackLanguage,
            usedFallback: false,
        };
    }
    const firstLanguage = entries[0][0];
    const candidates = [
        preferredLanguage,
        resolvedLanguage,
        fallbackLanguage,
        firstLanguage,
        'it',
        'en',
    ].filter((code, index, arr) => Boolean(code) && arr.indexOf(code) === index);
    const selectedLanguage = candidates.find(code => normalizedMap[code] !== undefined) ?? firstLanguage;
    const selectedValue = normalizedMap[selectedLanguage] ?? entries[0][1];
    return {
        value: selectedValue ?? null,
        language: selectedLanguage,
        usedFallback: Boolean(preferredLanguage && selectedLanguage !== preferredLanguage),
    };
}
